var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#0A1E60","fillRule":"evenodd","d":"M12.39 34.7V19.314h4.904L18.1 13.2h-5.71V8.967c0-.985.178-1.702.537-2.15.447-.537 1.276-.806 2.486-.806h3.224V.569C17.428.389 15.86.3 13.934.3c-2.374 0-4.277.705-5.71 2.116-1.434 1.411-2.15 3.393-2.15 5.947V13.2H.9v6.114h5.173V34.7h6.316Z"}));
}

Facebook.defaultProps = {"viewBox":"0 0 19 35"};

module.exports = Facebook;

Facebook.default = Facebook;
